import Request from 'core/api/Request';

export const fetcher = async (url: string) => {
  const response = await Request.get(url);
  return response.body;
};

export const post = async (url: string, data = {}) => {
  try {
    const response = await Request.post(url).send(data);
    return response.body;
  } catch (error) {
    console.error(error);
  }
};
